// extracted by mini-css-extract-plugin
export default {"loader":"AppLoader_loader__EXVQN","l7":"AppLoader_l7__9kv4h","primary":"AppLoader_primary__yU1zz","highlight":"AppLoader_highlight__CgKnx","xl":"AppLoader_xl__hXsj3"};